import BankAccount from 'models/BankAccount';

type BankAssignedType = {
  [entity: string]: BankAccount;
};

const bankAssigned: BankAssignedType = {
  '0008': {
    bic: 'BSABESBBXXX',
    description: 'BANCO ATLÁNTICO',
    iso: 'ESP',
  },
  '0019': {
    bic: 'DEUTESBBASS',
    description: 'DEUTSCHE BANK, S.A.E.',
    iso: 'ESP',
  },
  '0031': {
    bic: 'ETCHES2GXXX',
    description: 'BANCO ETCHEVERRIA, S.A.',
    iso: 'ESP',
  },
  '0046': {
    bic: 'GALEES2GXXX',
    description: 'BANCO GALLEGO, S.A.',
    iso: 'ESP',
  },
  '0049': {
    bic: 'BSCHESMMXXX',
    description: 'BANCO SANTANDER, S.A.',
    iso: 'ESP',
  },
  '0058': {
    bic: 'BNPAESMZXXX',
    description: 'BNP PARIBAS ESPAÑA, S.A.',
    iso: 'ESP',
  },
  '0059': {
    bic: 'MADRESMMXXX',
    description: 'BANCO DE MADRID, S.A.',
    iso: 'ESP',
  },
  '0061': {
    bic: 'BMARES2MXXX',
    description: 'BANCA MARCH, S.A.',
    iso: 'ESP',
  },
  '0065': {
    bic: 'BARCESMMXXX',
    description: 'BARCLAYS BANK, S.A.',
    iso: 'ESP',
  },
  '0075': {
    bic: 'POPUESMMXXX',
    description: 'BANCO POPULAR ESPAÑOL, S.A.',
    iso: 'ESP',
  },
  '0078': {
    bic: 'BAPUES22XXX',
    description: 'BANCA PUEYO, S.A.',
    iso: 'ESP',
  },
  '0081': {
    bic: 'BSABESBBXXX',
    description: 'BANCO DE SABADELL, S.A.',
    iso: 'ESP',
  },
  '0083': {
    bic: 'RENBESMMXXX',
    description: 'RENTA 4 BANCO, S.A.',
    iso: 'ESP',
  },
  '0093': {
    bic: 'VALEESVVXXX',
    description: 'BANCO DE VALENCIA, S.A.',
    iso: 'ESP',
  },
  '0094': {
    bic: 'BVALESMMXXX',
    description: 'RBC INVESTOR SERVICES ESPAÑA, S.A.',
    iso: 'ESP',
  },
  '0099': {
    bic: 'AHCRESVVXXX',
    description: 'BANKIA BANCA PRIVADA, S.A.U',
    iso: 'ESP',
  },
  '0108': {
    bic: 'SOGEESMMAGM',
    description: 'SOCIETE GENERALE, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0122': {
    bic: 'CITIES2XXXX',
    description: 'CITIBANK ESPAÑA, S.A.',
    iso: 'ESP',
  },
  '0128': {
    bic: 'BKBKESMMXXX',
    description: 'BANKINTER, S.A.',
    iso: 'ESP',
  },
  '0130': {
    bic: 'CGDIESMMXXX',
    description: 'BANCO CAIXA GERAL, S.A.',
    iso: 'ESP',
  },
  '0131': {
    bic: 'BESMESMMXXX',
    description: 'BANCO ESPIRITO SANTO, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0136': {
    bic: 'AREBESMMXXX',
    description: 'ARESBANK, S.A.',
    iso: 'ESP',
  },
  '0138': {
    bic: 'BKOAES22XXX',
    description: 'BANKOA, S.A.',
    iso: 'ESP',
  },
  '0144': {
    bic: 'PARBESMHXXX',
    description: 'BNP PARIBAS SECURITIES SERVICES, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0149': {
    bic: 'BNPAESMHXXX',
    description: 'BNP PARIBAS, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0152': {
    bic: 'BPLCESMMXXX',
    description: 'BARCLAYS BANK PLC, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0154': {
    bic: 'BSUIESMMXXX',
    description:
      'CREDIT AGRICOLE CORPORATE AND INVESTMENT BANK, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0155': {
    bic: 'BRASESMMXXX',
    description: 'BANCO DO BRASIL, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0156': {
    bic: 'ABNAESMMXXX',
    description: 'THE ROYAL BANK OF SCOTLAND PLC, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0159': {
    bic: 'COBAESMXTMA',
    description: 'COMMERZBANK AKTIENGESELLSCHAFT, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0160': {
    bic: 'BOTKESMXXXX',
    description: 'THE BANK OF TOKYO-MITSUBISHI UFJ, LTD, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0162': {
    bic: 'MIDLESMXXXX',
    description: 'HSBC BANK PLC, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0167': {
    bic: 'GEBAESMMBIL',
    description: 'BNP PARIBAS FORTIS, S.A., N.V., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0168': {
    bic: 'BBRUESMXXXX',
    description: 'ING BELGIUM, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0169': {
    bic: 'NACNESMMXXX',
    description: 'BANCO DE LA NACION ARGENTINA, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0182': {
    bic: 'BBVAESMMXXX',
    description: 'BANCO BILBAO VIZCAYA ARGENTARIA, S.A.',
    iso: 'ESP',
  },
  '0186': {
    bic: 'BFIVESBBXXX',
    description: 'BANCO MEDIOLANUM, S.A.',
    iso: 'ESP',
  },
  '0188': {
    bic: 'ALCLESMMXXX',
    description: 'BANCO ALCALA, S.A.',
    iso: 'ESP',
  },
  '0190': {
    bic: 'BBPIESMMXXX',
    description: 'BANCO BPI, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  '0196': {
    bic: 'WELAESMMFUN',
    description: 'PORTIGON AG, SUCURSAL EN ESPAÑA',
    iso: 'ESP',
  },
  '0198': {
    bic: 'BCOEESMMXXX',
    description: 'BANCO COOPERATIVO ESPAÑOL, S.A.',
    iso: 'ESP',
  },
  '0211': {
    bic: 'PROAESMMXXX',
    description: 'EBN BANCO DE NEGOCIOS, S.A.',
    iso: 'ESP',
  },
  '0216': {
    bic: 'POHIESMM',
    description: 'TARGOBANK, S.A.',
    iso: 'ESP',
  },
  '0219': {
    bic: 'BMCEESMMXXX',
    description: 'BANQUE MAROCAINE COMMERCE EXTERIEUR INTERNATIONAL, S.A.',
    iso: 'ESP',
  },
  '0226': {
    bic: 'UBSWESMMNPB',
    description: 'UBS BANK, S.A.',
    iso: 'ESP',
  },
  '0229': {
    bic: 'POPLESMMXXX',
    description: 'BANCO POPULAR-E, S.A.',
    iso: 'ESP',
  },
  '0231': {
    bic: 'DSBLESMMXXX',
    description: 'DEXIA SABADELL, S.A.',
    iso: 'ESP',
  },
  '0232': {
    bic: 'INVLESMMXXX',
    description: 'BANCO INVERSIS, S.A.',
    iso: 'ESP',
  },
  '0233': {
    bic: 'POPIESMMXXX',
    description: 'POPULAR BANCA PRIVADA, S.A.',
    iso: 'ESP',
  },
  '0234': {
    bic: 'CCOCESMMXXX',
    description: 'BANCO CAMINOS, S.A.',
    iso: 'ESP',
  },
  '0236': {
    bic: 'LOYIESMMXXX',
    description: 'LLOYDS BANK INTERNATIONAL, S.A.U.',
    iso: 'ESP',
  },
  '0237': {
    bic: 'CSURES2CXXX',
    description: 'CAJASUR BANCO, S.A',
    iso: 'ESP',
  },
  '0487': {
    bic: 'GBMNESMMXXX',
    description: 'BANCO MARE NOSTRUM, S.A.',
    iso: 'ESP',
  },
  '0488': {
    bic: 'BFASESMM',
    description: 'BANCO FINANCIERO Y DE AHORRO, S.A.',
    iso: 'ESP',
  },
  1000: {
    bic: 'ICROESMMXXX',
    description: 'INSTITUTO DE CREDITO OFICIAL.',
    iso: 'ESP',
  },
  1459: {
    bic: 'PRABESMMXXX',
    description:
      'COOP. CENTR. RAIFFEISEN-BOERENL. (RABOBANK NED.), SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1460: {
    bic: 'CRESESMMXXX',
    description: 'CREDIT SUISSE AG, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1465: {
    bic: 'INGDESMMXXX',
    description: 'ING DIRECT, N.V., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1467: {
    bic: 'EHYPESMXXXX',
    description: 'HYPOTHEKENBANK FRANKFURT AG. SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1474: {
    bic: 'CITIESMXSEC',
    description: 'CITIBANK INTERNATIONAL PLC, SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1479: {
    bic: 'NATXESMMXXX',
    description: 'NATIXIS, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1497: {
    bic: 'ESSIESMMXXX',
    description:
      'BANCO ESPIRITO SANTO DE INVESTIMENTO, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  1524: {
    bic: 'UBIBESMMXXX',
    description: 'UBI BANCA INTERNATIONAL, S.A., SUCURSAL EN ESPAÑA.',
    iso: 'ESP',
  },
  2000: {
    bic: 'CECAESMMXXX',
    description: 'CECABANK, S.A.',
    iso: 'ESP',
  },
  2013: {
    bic: 'CESCESBBXXX',
    description: 'CATALUNYA BANC, S.A.',
    iso: 'ESP',
  },
  2038: {
    bic: 'CAHMESMMXXX',
    description: 'BANKIA, S.A.',
    iso: 'ESP',
  },
  2045: {
    bic: 'CECAESMM045',
    description: 'CAJA DE AHORROS Y M.P. DE ONTINYENT.',
    iso: 'ESP',
  },
  2048: {
    bic: 'CECAESMM048',
    description: 'LIBERBANK, S.A.',
    iso: 'ESP',
  },
  2056: {
    bic: 'CECAESMM056',
    description: 'COLONYA - CAIXA D?ESTALVIS DE POLLENSA.',
    iso: 'ESP',
  },
  2080: {
    bic: 'CAGLESMMXXX',
    description: 'NCG BANCO, S.A.',
    iso: 'ESP',
  },
  2085: {
    bic: 'CAZRES2ZXXX',
    description: 'IBERCAJA BANCO, S.A.',
    iso: 'ESP',
  },
  2086: {
    bic: 'CECAESMM086',
    description: 'BANCO GRUPO CAJATRES, S.A.',
    iso: 'ESP',
  },
  2095: {
    bic: 'BASKES2BXXX',
    description: 'KUTXABANK, S.A.',
    iso: 'ESP',
  },
  2100: {
    bic: 'CAIXESBBXXX',
    description: 'CAIXABANK, S.A.',
    iso: 'ESP',
  },
  2103: {
    bic: 'UCJAES2MXXX',
    description: 'UNICAJA BANCO, S.A.',
    iso: 'ESP',
  },
  2105: {
    bic: 'CECAESMMXXX',
    description: 'CAJA CASTILLA LA MANCHA',
    iso: 'ESP',
  },
  2108: {
    bic: 'CSPAES2L108',
    description: 'BANCO DE CAJA ESPAÑA DE INVERSIONES, SALAMANCA Y SORIA, S.A.',
    iso: 'ESP',
  },
  3025: {
    bic: 'CDENESBBXXX',
    description: 'CAIXA DE C. DELS ENGINYERS C.C. INGENIEROS, S.C.C.',
    iso: 'ESP',
  },
  3035: {
    bic: 'CLPEES2MXXX',
    description: 'CAJA LABORAL POPULAR, C.C.',
    iso: 'ESP',
  },
  3058: {
    bic: 'CCRIES2AXXX',
    description: 'CAJAS RURALES UNIDAS, S.C.C.',
    iso: 'ESP',
  },
  3081: {
    bic: 'BCOEESMM081',
    description: 'CAJA R. DE CASTILLA-LA MANCHA, S.C.C.',
    iso: 'ESP',
  },
  3183: {
    bic: 'CASDESBBXXX',
    description: 'CAJA DE ARQUITECTOS S.C.C.',
    iso: 'ESP',
  },
  3501: {
    bic: 'RENTESMMXXX',
    description: 'RENTA 4 SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3524: {
    bic: 'AHCFESMMXXX',
    description: 'AHORRO CORPORACION FINANCIERA, S.A., SOCIEDAD DE VALORES',
    iso: 'ESP',
  },
  3563: {
    bic: 'MISVESMMXXX',
    description: 'MAPFRE INVERSION, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3575: {
    bic: 'INSGESMMXXX',
    description: 'INVERSEGUROS, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3604: {
    bic: 'CAPIESMMXXX',
    description: 'CM CAPITAL MARKETS BOLSA, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3641: {
    bic: 'LISEESMMXXX',
    description: 'LINK SECURITIES, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3656: {
    bic: 'CSSOES2SFIN',
    description: 'FINANDUERO, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3661: {
    bic: 'MLCEESMMXXX',
    description:
      'MERRILL LYNCH CAPITAL MARKETS ESPAÑA, S.A., SOCIEDAD DE VALORES.',
    iso: 'ESP',
  },
  3669: {
    bic: 'IVALESMMXXX',
    description: 'INTERMONEY VALORES, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  3682: {
    bic: 'GVCBESBBETB',
    description: 'GVC GAESCO VALORES, SOCIEDAD DE VALORES, S.A.',
    iso: 'ESP',
  },
  9000: {
    bic: 'ESPBESMMXXX',
    description: 'BANCO DE ESPAÑA.',
    iso: 'ESP',
  },
  9020: {
    bic: 'IPAYESMMXXX',
    description: 'SOCIEDAD ESPAÑOLA DE SISTEMAS DE PAGO, S.A.',
    iso: 'ESP',
  },
  9091: {
    bic: 'XBCNESBBXXX',
    description: 'SDAD. RECTORA BOLSA VALORES DE BARCELONA, S.A., SRBV.',
    iso: 'ESP',
  },
  9092: {
    bic: 'XRBVES2BXXX',
    description: 'SDAD. RECTORA BOLSA DE VALORES DE BILBAO, S.A., SRBV.',
    iso: 'ESP',
  },
  9093: {
    bic: 'XRVVESVVXXX',
    description: 'SDAD. RECTORA BOLSA VALORES DE VALENCIA, S.A., SRBV.',
    iso: 'ESP',
  },
  9094: {
    bic: 'MEFFESBBXXX',
    description: 'MEFF SOCIEDAD RECTORA DE PRODUCTOS DERIVADOS S.A.U.',
    iso: 'ESP',
  },
  9096: {
    bic: 'IBRCESMMXXX',
    description: 'SOC. GEST. SIST. REGIST. Y LIQUID. VALORES.',
    iso: 'ESP',
  },
};

export { bankAssigned };
